import { useState, useCallback } from 'react';
import type React from 'react';
import type { MapPin, NoteIcon } from '@roll1/shared';
import type { UseMultiplayerReturn } from './useMultiplayer';

export interface UsePinsReturn {
  pins: MapPin[];
  setPins: React.Dispatch<React.SetStateAction<MapPin[]>>;
  createPin: (pageId: string, x: number, y: number, icon: NoteIcon, color: string, visibility: 'gm' | 'all' | 'owner', journalEntryId?: string | null) => void;
  updatePin: (pageId: string, pinId: string, changes: Partial<Pick<MapPin, 'icon' | 'color' | 'visibility' | 'journalEntryId'>>) => void;
  deletePin: (pageId: string, pinId: string) => void;
  movePin: (pageId: string, pinId: string, x: number, y: number) => void;
}

export function usePins(mp: UseMultiplayerReturn): UsePinsReturn {
  const [pins, setPins] = useState<MapPin[]>([]);

  const createPin = useCallback((
    pageId: string, x: number, y: number,
    icon: NoteIcon, color: string, visibility: 'gm' | 'all' | 'owner',
    journalEntryId?: string | null,
  ) => {
    mp.send({ type: 'pin:create', pageId, x, y, icon, color, visibility, journalEntryId: journalEntryId ?? null });
  }, [mp]);

  const updatePin = useCallback((
    pageId: string, pinId: string,
    changes: Partial<Pick<MapPin, 'icon' | 'color' | 'visibility' | 'journalEntryId'>>,
  ) => {
    mp.send({ type: 'pin:update', pageId, pinId, changes });
  }, [mp]);

  const deletePin = useCallback((pageId: string, pinId: string) => {
    mp.send({ type: 'pin:delete', pageId, pinId });
  }, [mp]);

  const movePin = useCallback((pageId: string, pinId: string, x: number, y: number) => {
    mp.send({ type: 'pin:move', pageId, pinId, x, y });
  }, [mp]);

  return { pins, setPins, createPin, updatePin, deletePin, movePin };
}
